module.exports = __webpack_public_path__ + "static/media/background.70729201.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CurrentAirQualityView/background.jpg
// module id = 885
// module chunks = 0